import { Component, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { IListOfUsers } from '../../../interface/administrator/admin';
import { HttpClient } from '@angular/common/http';
import { AdminService } from '../../../services/administrator/admin.service';
import { MatDialog } from '@angular/material/dialog';
import { AddUpdateRemoveUserComponent } from './add-update-remove-user/add-update-remove-user.component';
import { MatPaginator } from '@angular/material/paginator';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../shared/module/material.module';
import { SharedServices } from '../../../shared/services/shared.services';
import { ConfirmdialogComponent } from '../../../shared/component/confirmdialog/confirmdialog.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-users-setup',
  imports: [MaterialModule, CommonModule],
  templateUrl: './users-setup.component.html',
  styleUrls: ['./users-setup.component.css']
})
export class UsersSetupComponent implements OnInit, AfterViewInit {
  title = 'Users Setup';
  isLoading: boolean = false;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  DisplayedColumns: string[] = [
    'serialNo',
    'email',
    'name',
    'accessType',
    'actions'
  ];
  excelData: any;

  dataSource = new MatTableDataSource<IListOfUsers>();
  constructor(private http: HttpClient, private sharedService:SharedServices, private adminservice: AdminService, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.getUsers();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  getUsers(): Observable<IListOfUsers[]> {
    this.adminservice.getUsersList()
      .subscribe((data: IListOfUsers[]) => {
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
        this.isLoading = false;
        this.excelData = this.dataSource.data.map((item, index) => ({
          ...item,
          'S/No': index + 1,
          'Name': item.name ?? '',
          'CAI': item.cai ?? '',
          'Email': item.emailAddress ?? '',
          'Access Type': this.mapAccessType(item['accessType'])
        }));
      }, error => {
        console.error('Error fetching users', error);
        this.isLoading = false;
      });
      return this.adminservice.getUsersList(); 
  }

  openAddDialog(): void {
    const dialogRef = this.dialog.open(AddUpdateRemoveUserComponent, {
      width: '400px',
      height: '350px',
      data: { isEdit: false, isRemove: false, users: this.dataSource.data },
      panelClass: 'custom-dialog-container'
    });
  
    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.getUsers();
    });
  }
  
  openUpdateDialog(element: IListOfUsers): void {
    const dialogRef = this.dialog.open(AddUpdateRemoveUserComponent, {
      width: '400px',
      height: '350px',
      data: { isEdit: true, isRemove: false, user: element, users: this.dataSource.data },
      panelClass: 'custom-dialog-container'
    });
  
    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.getUsers();
    });
  }
  
  removeUser(element: IListOfUsers): void {
        const dialogRef = this.dialog.open(ConfirmdialogComponent, {
          width: 'auto',
          position: { top: '1'},
        data: { message: 'Are you sure you want to delete the User?' }
        });
      
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.isLoading = true;
            this.adminservice.deleteUser(element.id).subscribe({
              next: response => {
                this.getUsers().subscribe({
                  next: () => {
                    this.sharedService.openModal('Message', 'Removed Successfully');
                    this.isLoading = false;
                  },
                  error: error => {
                    console.error('Error fetching users', error);
                    this.isLoading = false;
                  }
                });
              },
              error: error => {
                console.error('Error removing users', error);
                this.isLoading = false;
              }
            });
          }
        });
      }

  applyFilter(event: Event, column: string): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filterPredicate = (data: IListOfUsers, filter: string) => {
      const filters = JSON.parse(filter);
      return Object.keys(filters).every(key => {
        const textToSearch = data[key as keyof IListOfUsers] && data[key as keyof IListOfUsers].toString().toLowerCase() || '';
        return textToSearch.indexOf(filters[key]) !== -1;
      });
    };
  
    const currentFilters = this.dataSource.filter ? JSON.parse(this.dataSource.filter) : {};
    currentFilters[column] = filterValue;
    this.dataSource.filter = JSON.stringify(currentFilters);
  
    const filteredData = this.dataSource.filteredData.map((item, index) => ({
      ...item,
      'S/No': index + 1,
      'Name': item.name ?? '',
      'Email': item.emailAddress ?? '',
      'Access Type': this.mapAccessType(item['accessType'])
    }));
    this.excelData = filteredData;
  }

  mapAccessType(accessType: string): string {
    switch (accessType) {
      case 'A': return 'Administrator';
      case 'P': return 'Payroll User';
      case 'D': return 'Developer';
      case 'U': return 'DOA Update';
      default: return accessType;
    }
  }

  downloadExcel(): void {
    this.adminservice.getUsersWorksheet(this.excelData).subscribe(
      (data: Blob) => {
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `UsersList_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      error => {
        console.error('Error downloading the file', error);
      }
    );
  }
}
